import React from "react";
import "../styles/hero-three.scss";
import { Link } from "react-router-dom";

const HeroThree = () => {
  return (
    <section className="hero-3" id="hero">
      {/* Background video */}
      <video className="hero-3__video" autoPlay loop muted playsInline>
        <source src="assets/img/clip_david.mp4" type="video/mp4" />
      </video>

      {/* Black overlay */}
      <div className="hero-3__overlay" />

      <div className="hero-3__content container">
        <h1 className="hero-3__title">Meet Human-Led, Tech-Powered Expertise</h1>

        <div className="hero-3__cards">
          {/* Left card */}
          <div className="hero-3__card hero-3__card--left" id="hero-enterprise-cta">
            <p className="hero-3__card-title">
              I know an organisation that needs expert&nbsp;support.
            </p>
            <p className="hero-3__signup">Sign Up Now</p>

            <a href="https://tenders.kiubunifu.com/" className="hero-3__btn">
              Submit a Tender
            </a>
          </div>

          {/* Right card */}
          <div className="hero-3__card hero-3__card--right" id="hero-professional-cta">
            <p className="hero-3__card-title">
              I am available to provide the needed support.
            </p>
            <p className="hero-3__signup">Sign Up Now</p>

            <a href="https://affiliates.kiubunifu.com/" className="hero-3__btn">
              Become an Affiliate
            </a>
          </div>
        </div>
      </div>

      {/* T&Cs pinned to bottom of hero */}
      <p className="hero-3__tnc">Terms &amp; Conditions Apply</p>
    </section>
  );
};

export default HeroThree;